export const INKLE_PRICING_URL = "https://www.inkle.io/pricing";
export const INKLE_BOOKS_PRICING_URL =
  "https://www.inkle.io/pricing#inkle-books";
export const INKLE_TAX_PRICING_URL = "https://www.inkle.io/pricing#Inkle%20Tax";
